export default __webpack_public_path__ + "static/visual-noise-dont-567be8bf3238262cfc46d4e48804eef7.png";